import { useMutation, useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';

const useAccountAdminConfig = ({ accountId, adminId, isUbeyaAdmin }) => {
  const queryClient = useQueryClient();

  const storeKey = ['account-admin-config', accountId, adminId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchAccountAdminconfig({ accountId, adminId }), {
    staleTime: 0,
    enabled: !!accountId && !!adminId && !isUbeyaAdmin
  });

  const { mutateAsync: updateAdminConfig } = useMutation(
    (params) => api.updateAccountAdminConfig({ accountId, adminId, ...params }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('account-admin-config');
        queryClient.invalidateQueries('user');
      }
    }
  );

  return { isLoading, updateAdminConfig, adminConfigData: data?.data || {} };
};

export default useAccountAdminConfig;
